<template>
    <form @submit.prevent="submit" class="form activation-plan view">
        <div class="row">
            <div class="span-9">
                <h2 class="title form__title view__title">
                    Активация
                </h2>

                <p class="text">
                    Вы&nbsp;можете активировать Программы ДМС с&nbsp;франшизой по&nbsp;Вашему полису
                    <span style="white-space: nowrap">
                        №<span style="opacity: 0.4">{{ policy.number }}</span>
                    </span>
                    ,указав данные Вашей банковской карты для автоматических списаний суммы франшизы. Без активации Программы с&nbsp;франшизой, Вы&nbsp;не&nbsp;сможете воспользоваться услугами в&nbsp;медицинских учреждениях, по&nbsp;которым она предусмотрена.
                </p>
                <p class="text">
                    Для активации программы ДМС в&nbsp;части франшизы Вам необходимо:
                </p>

                <ul class="steps-list activation-plan__steps">
                    <li class="steps-list__item"
                        :key="`steps_list_${idx}`"
                        v-for="(step, idx) in steps">
                        <div class="steps-list__item-icon">
                            <span class="steps-list__item-icon-number">{{ idx + 1 }}</span>
                        </div>
                        <p class="text" v-html="step.text"></p>
                    </li>
                </ul>

                <p class="text">
                    После активации Программы с&nbsp;франшизой&nbsp;Вы сможете обращаться в&nbsp;медицинские учреждения, в&nbsp;которых предусмотрена франшиза
                </p>

                <div class="activation-plan__submit form__buttons">
                    <button class="button button--lg button--primary">
                        Активировать
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            steps: [
                { text: 'Ознакомиться с&nbsp;правовыми документами и&nbsp;принять все условия, подписав их&nbsp;простой электронной подписью.' },
                { text: 'Указать номер телефона для получения уведомлений о&nbsp;списании с&nbsp;карты суммы франшизы.' },
                { text: 'Ввести данные Вашей банковской карты, с&nbsp;которой будет списан 1&nbsp;рубль для её&nbsp;проверки, а&nbsp;затем возвращен Вам. В&nbsp;дальнейшем эта карта будет использоваться для оплаты франшизы путем автоматического безакцептного списания.' }
            ]
        }
    },
    computed: {
        ...mapGetters({
            policy: 'policy/policy'
        })
    },
    methods: {
        submit () {
            this.$emit('next')
        }
    }
}
</script>

<style lang="scss">
    .activation-plan__steps {
        @include mq(desktop) {
            margin: 60px 0 50px;
        }
        @include mq(mobile) {
            margin-top: 30px;
            margin-bottom: 50px;
        }
    }
</style>
